/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SuprSendJwtTokenResponse
 */
export interface SuprSendJwtTokenResponse {
    /**
     * Generated JWT token
     * @type {string}
     * @memberof SuprSendJwtTokenResponse
     */
    token: string;
    /**
     * Token expiration timestamp
     * @type {number}
     * @memberof SuprSendJwtTokenResponse
     */
    expires_at: number;
}

/**
 * Check if a given object implements the SuprSendJwtTokenResponse interface.
 */
export function instanceOfSuprSendJwtTokenResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "token" in value;
    isInstance = isInstance && "expires_at" in value;

    return isInstance;
}

export function SuprSendJwtTokenResponseFromJSON(json: any): SuprSendJwtTokenResponse {
    return SuprSendJwtTokenResponseFromJSONTyped(json, false);
}

export function SuprSendJwtTokenResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuprSendJwtTokenResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
        'expires_at': json['expires_at'],
    };
}

export function SuprSendJwtTokenResponseToJSON(value?: SuprSendJwtTokenResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
        'expires_at': value.expires_at,
    };
}

